import React, { useEffect } from 'react';
import { useDriverLocation } from '../../hooks/useDriverLocation';
import { emitDriverLocation } from '../../services/websocketService';
import { useAuth } from '../../context/AuthContext';
import { Radio } from 'lucide-react';

interface LocationBroadcasterProps {
    activeJobs: any[];
}

const LocationBroadcaster: React.FC<LocationBroadcasterProps> = ({ activeJobs }) => {
    const { user } = useAuth();

    // Protocol G: Privacy Guard
    // Only track if there is at least one order that is 'out_for_delivery'
    const shouldTrack = activeJobs.some(job => job.status === 'out_for_delivery');

    const { location, isBroadcasting, error } = useDriverLocation(shouldTrack);

    useEffect(() => {
        if (location && user && shouldTrack) {
            // Find the primary active order (just pick first one for now as per simple scope)
            const activeOrder = activeJobs.find(job => job.status === 'out_for_delivery');

            // Emit to Socket
            // Payload must match ADR-010
            emitDriverLocation({
                driverId: (user as any).id || (user as any)._id, // Handle ID variance
                orderId: activeOrder?._id,
                location: {
                    lat: location.lat,
                    lng: location.lng,
                    heading: location.heading || 0,
                    speed: location.speed || 0
                }
            });

        }
    }, [location, user, shouldTrack, activeJobs]);

    if (!shouldTrack) return null;

    return (
        <div className="bg-blue-600 text-white px-4 py-2 flex items-center justify-between shadow-md">
            <div className="flex items-center gap-2">
                <Radio className="w-4 h-4 animate-pulse" />
                <span className="text-xs font-bold uppercase tracking-wider">Broadcasting Live Location</span>
            </div>
            {error && <span className="text-xs bg-red-500 px-2 py-0.5 rounded ml-2">GPS Error</span>}
        </div>
    );
};

export default LocationBroadcaster;
